import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout/layout'

// 路由跳转重复解决
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

export default new Router({
  routes: [
    /**{
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }**/
    // {
    //   path: '/',
    //   redirect: '/Admittance',
    // },
    {
      path: '/',
      redirect: '/Login',
    },
    // {
    //   path: '/Register',
    //   component: resolve => require(['@/views/layout/Register'], resolve),
    //   name: 'Register',
    // },

    {
      path: '/LoginTips',
      component: resolve => require(['@/views/Layout/LoginTips'], resolve),
      name: 'LoginTips',
    },
    {
      path: '/Login',
      component: resolve => require(['@/views/Layout/Login'], resolve),
      name: 'Login',
    },
    //找回密码
    {
      path: '/RetrievePassword',
      component: resolve => require(['@/views/Layout/RetrievePassword'], resolve),
      name: 'RetrievePassword',
    },
    //个人-注册
    {
      path: '/AccountInformation',
      component: resolve => require(['@/views/Register/AccountInformation'], resolve),
      name: 'AccountInformation',
    },
    // 企业-注册
    {
      path: '/EnterpriseInformation',
      component: resolve => require(['@/views/Register/EnterpriseInformation'], resolve),
      name: 'EnterpriseInformation',
    },
    // 注册完成
    {
      path: '/Achieve',
      component: resolve => require(['@/views/Register/Achieve'], resolve),
      name: 'Achieve',
    },
    // 协议
    {
      path: '/Protocol',
      component: resolve => require(['@/views/Register/Protocol'], resolve),
      name: 'Protocol',
    },
    // 协议
    {
      path: '/financeGuide',
      component: resolve => require(['@/views/guide/FinanceGuide'], resolve),
      name: 'Protocol',
    },

    {
      path: '/greditGuide',
      component: resolve => require(['@/views/guide/GreditGuide'], resolve),
      name: 'Protocol',
    },

    {
      path: '/guaranteeGuide',
      component: resolve => require(['@/views/guide/GuaranteeGuide'], resolve),
      name: 'Protocol',
    },
    {
      path: '/Layout',  //访问路径
      name: 'Layout', // 路径名
      component: Layout, //访问的组件,即访问‘/’,它会加载 Layouts 组件所有的内容。
      meta: {
        title: '首页'
      },
      children: [
        {
          path: '/AccessReportQuery',
          component: resolve => require(['@/views/AccessReportQuery'], resolve),
          name: 'AccessReportQuery',
        },
        //我的消息
        {
          path: '/myNews',
          component: resolve => require(['@/views/PersonalCenter/MyNews'], resolve),
          name: 'myNews',
        },
        {
          path: '/indexpay',
          component: resolve => require(['@/views/PersonalCenter/indexpay'], resolve),
          name: 'indexpay',
        },

        //企业信息里的用户修改
        {
          path: '/informationChanges',
          component: resolve => require(['@/views/BasicInformation/informationChanges'], resolve),
          name: 'informationChanges',
        },
        //我的订单
        {
          path: '/myOrder',
          component: resolve => require(['@/views/PersonalCenter/MyOrder'], resolve),
          name: 'myOrder',
        },
        // 我的订单详情
        {
          path: '/Invoicedetails',
          component: resolve => require(['@/views/PersonalCenter/Invoicedetails'], resolve),
          name: 'Invoicedetails',
        },
        //我的发票
        {
          path: '/Myinvoice',
          component: resolve => require(['@/views/PersonalCenter/Myinvoice'], resolve),
          name: 'Myinvoice',
        },
        {
          path: '/hmqA',
          component: resolve => require(['@/views/Qa/hmqA'], resolve),
          name: 'hmqA',
        },
        {
          path: '/UserInfo',
          component: resolve => require(['@/views/user/UserInfo'], resolve),
          name: 'UserInfo',
        },
        //修改密码

        {
          path: '/PasswordChange',
          component: resolve => require(['@/views/PassChanges/PasswordChange'], resolve),
          name: 'PasswordChange',
        },
        // 基本信息
        {
          path: '/PrimarySurface',
          component: resolve => require(['@/views/BasicInformation/PrimarySurface'], resolve),
          name: 'PrimarySurface',
        },
        {
          path: '/InFormaTionDisplay',
          component: resolve => require(['@/views/PersonaLDetailShow/InFormaTionDisplay'], resolve),
          name: 'InFormaTionDisplay',
        },


        // 供应商
        {
          path: '/SupplierAccesslist',
          component: resolve => require(['@/views/SuppLier/SupplierAccesslist'], resolve),
          name: 'SupplierAccesslist',
        },
        {
          path: '/Admittance',
          component: resolve => require(['@/views/SuppLier/Admittance'], resolve),
          name: 'Admittance',
        },
        // 准入报告---填报信息
        {
          path: '/supplierSub',
          component: resolve => require(['@/views/SuppLier/supplierSub'], resolve),
          name: 'supplierSub',
        },
        {
          path: '/EnterApplicaTion',
          component: resolve => require(['@/views/Grade/EnterApplicaTion'], resolve),
          name: 'EnterApplicaTion',
        },
        {
          path: '/RatingFor',
          component: resolve => require(['@/views/Grade/RatingFor'], resolve),
          name: 'RatingFor',
        },
        // 评级申请
        {
          path: '/InformationProvided',
          component: resolve => require(['@/views/Enterprise/InformationProvided'], resolve),
          name: 'InformationProvided',
        },
        {
          path: '/paymentPay',
          component: resolve => require(['@/views/Enterprise/paymentPay'], resolve),
          name: 'paymentPay',
        },
        {
          path: '/Audition',
          component: resolve => require(['@/views/Enterprise/Audition'], resolve),
          name: 'Audition',
        },
        {
          path: '/RatingComplete',
          component: resolve => require(['@/views/Enterprise/RatingComplete'], resolve),
          name: 'RatingComplete',
        },
        {
          path: '/Effect',
          component: resolve => require(['@/views/Enterprise/Effect'], resolve),
          name: 'Effect',
        },
        {
          path: '/Putinoff',
          component: resolve => require(['@/views/Enterprise/Putinoff'], resolve),
          name: 'Putinoff',
        },
        {
          path: '/PayJudgment',
          component: resolve => require(['@/views/Enterprise/PayJudgment'], resolve),
          name: 'PayJudgment',
        },
        {
          path: '/biddingAgent',
          component: resolve => require(['@/views/Enterprise/biddingAgent'], resolve),
          name: 'biddingAgent',
        },


        //支付超时
        {
          path: '/PayOvertime',
          component: resolve => require(['@/views/Enterprise/PayOvertime'], resolve),
          name: 'PayOvertime',
        },

        //查看上传资料
        {
          path: '/dataPage',
          component: resolve => require(['@/views/CheckData/DataPage'], resolve),
          name: 'dataPage',
          children: [
            {
              path: 'basicInformation',
              component: resolve => require(['@/views/CheckData/BasicInformation'], resolve),
              name: 'basicInformation',
            },
            {
              path: 'CheckToSubmit',
              component: resolve => require(['@/views/CheckData/CheckToSubmit'], resolve),
              name: 'CheckToSubmit',
            },
            {
              path: 'GovernmentSupport',
              component: resolve => require(['@/views/CheckData/GovernmentSupport'], resolve),
              name: 'GovernmentSupport',
            },
            {
              path: 'StandardPer',
              component: resolve => require(['@/views/CheckData/StandardPer'], resolve),
              name: 'StandardPer',
            },
            {
              path: 'FixedAssets',
              component: resolve => require(['@/views/CheckData/FixedAssets'], resolve),
              name: 'FixedAssets',
            },
            {
              path: 'Capital',
              component: resolve => require(['@/views/CheckData/Capital'], resolve),
              name: 'Capital',
            },
            {
              path: 'FinancialData',
              component: resolve => require(['@/views/CheckData/FinancialData'], resolve),
              name: 'FinancialData',
            },
            {
              path: 'Security',
              component: resolve => require(['@/views/CheckData/Security'], resolve),
              name: 'Security',
            },
            {
              path: 'Financing',
              component: resolve => require(['@/views/CheckData/Financing'], resolve),
              name: 'Financing',
            },
            {
              path: 'Survey',
              component: resolve => require(['@/views/CheckData/Survey'], resolve),
              name: 'Survey',
            },
            {
              path: 'Operation',
              component: resolve => require(['@/views/CheckData/Operation'], resolve),
              name: 'Operation',
            },
            {
              path: 'Technical',
              component: resolve => require(['@/views/CheckData/Technical'], resolve),
              name: 'Technical',
            },
            {
              path: 'Employment',
              component: resolve => require(['@/views/CheckData/Employment'], resolve),
              name: 'Employment',
            },
            {
              path: 'Enterprisehonor',
              component: resolve => require(['@/views/CheckData/Enterprisehonor'], resolve),
              name: 'Enterprisehonor',
            },
            {
              path: 'Framework',
              component: resolve => require(['@/views/CheckData/Framework'], resolve),
              name: 'Framework',
            },
            {
              path: 'TheAttachment',
              component: resolve => require(['@/views/CheckData/TheAttachment'], resolve),
              name: 'TheAttachment',
            },
            {
              path: 'licenseAndQua',
              component: resolve => require(['@/views/CheckData/licenseAndQua'], resolve),
              name: 'licenseAndQua',
            },




            //股东及出资信息
            {
              path: 'ShareholderInvestment',
              component: resolve => require(['@/views/CheckData/ShareholderInvestment'], resolve),
              name: 'ShareholderInvestment',
            },
            {
              path: 'PrincipalManager',
              component: resolve => require(['@/views/CheckData/PrincipalManager'], resolve),
              name: 'PrincipalManager',
            },
            {
              path: 'OtherExecutiveInformation',
              component: resolve => require(['@/views/CheckData/OtherExecutiveInformation'], resolve),
              name: 'OtherExecutiveInformation',
            },
          ]
        },
        //招标代理评价
        //查看上传资料
        {
          path: '/dataPagezbdl',
          component: resolve => require(['@/views/CheckDatazbdl/DataPage'], resolve),
          name: 'dataPagezbdl',
          children: [
            {
              path: 'basicInformation',
              component: resolve => require(['@/views/CheckDatazbdl/BasicInformation'], resolve),
              name: 'basicInformation',
            },
            {
              path: 'CheckToSubmit',
              component: resolve => require(['@/views/CheckDatazbdl/CheckToSubmit'], resolve),
              name: 'CheckToSubmit',
            },
            {
              path: 'GovernmentSupport',
              component: resolve => require(['@/views/CheckDatazbdl/GovernmentSupport'], resolve),
              name: 'GovernmentSupport',
            },
            {
              path: 'StandardPer',
              component: resolve => require(['@/views/CheckDatazbdl/StandardPer'], resolve),
              name: 'StandardPer',
            },
            {
              path: 'FixedAssets',
              component: resolve => require(['@/views/CheckDatazbdl/FixedAssets'], resolve),
              name: 'FixedAssets',
            },
            {
              path: 'Capital',
              component: resolve => require(['@/views/CheckDatazbdl/Capital'], resolve),
              name: 'Capital',
            },
            {
              path: 'FinancialData',
              component: resolve => require(['@/views/CheckDatazbdl/FinancialData'], resolve),
              name: 'FinancialData',
            },
            {
              path: 'Security',
              component: resolve => require(['@/views/CheckDatazbdl/Security'], resolve),
              name: 'Security',
            },
            {
              path: 'Financing',
              component: resolve => require(['@/views/CheckDatazbdl/Financing'], resolve),
              name: 'Financing',
            },
            {
              path: 'Survey',
              component: resolve => require(['@/views/CheckDatazbdl/Survey'], resolve),
              name: 'Survey',
            },
            {
              path: 'Operation',
              component: resolve => require(['@/views/CheckDatazbdl/Operation'], resolve),
              name: 'Operation',
            },
            // {
            //   path: 'Operations',
            //   component: resolve => require(['@/views/CheckDatazbdl/Operations'], resolve),
            //   name: 'Operations',
            // },
            {
              path: 'Technical',
              component: resolve => require(['@/views/CheckDatazbdl/Technical'], resolve),
              name: 'Technical',
            },
            {
              path: 'Employment',
              component: resolve => require(['@/views/CheckDatazbdl/Employment'], resolve),
              name: 'Employment',
            },
            {
              path: 'Employments',
              component: resolve => require(['@/views/CheckDatazbdl/Employments'], resolve),
              name: 'Employments',
            },
            {
              path: 'Enterprisehonor',
              component: resolve => require(['@/views/CheckDatazbdl/Enterprisehonor'], resolve),
              name: 'Enterprisehonor',
            },
            {
              path: 'Framework',
              component: resolve => require(['@/views/CheckDatazbdl/Framework'], resolve),
              name: 'Framework',
            },
            {
              path: 'TheAttachment',
              component: resolve => require(['@/views/CheckDatazbdl/TheAttachment'], resolve),
              name: 'TheAttachment',
            },
            {
              path: 'licenseAndQua',
              component: resolve => require(['@/views/CheckDatazbdl/licenseAndQua'], resolve),
              name: 'licenseAndQua',
            },
            //股东及出资信息
            {
              path: 'ShareholderInvestment',
              component: resolve => require(['@/views/CheckDatazbdl/ShareholderInvestment'], resolve),
              name: 'ShareholderInvestment',
            },
            {
              path: 'PrincipalManager',
              component: resolve => require(['@/views/CheckDatazbdl/PrincipalManager'], resolve),
              name: 'PrincipalManager',
            },
            {
              path: 'OtherExecutiveInformation',
              component: resolve => require(['@/views/CheckDatazbdl/OtherExecutiveInformation'], resolve),
              name: 'OtherExecutiveInformation',
            },
          ]
        },
        //信用服务 reportInfo
        {
          path: '/creditService',
          component: resolve => require(['@/views/credit/creditService'], resolve),
          name: 'creditService',
        },
        {
          path: '/ReportInfo',
          component: resolve => require(['@/views/credit/ReportInfo'], resolve),
          name: 'ReportInfo',
        },
        //企业信用评价
        {
          path: '/enterpriseCreditRating',
          component: resolve => require(['@/views/priseCred/enterpriseCreditRating'], resolve),
          name: 'enterpriseCreditRating',
        },
        // 招标代理行业信用评价
        {
          path: '/creditEvaluationOfBiddingAgency',
          component: resolve => require(['@/views/BiddingAgency/creditEvaluationOfBiddingAgency'], resolve),
          name: 'creditEvaluationOfBiddingAgency',
        },
        //企业基础信用报告
        {
          path: '/greenReportList',
          component: resolve => require(['@/views/greenReport/greenReportList'], resolve),
          name: 'greenReportList',
        },
        {
          path: '/greenReport',
          component: resolve => require(['@/views/greenReport/greenReport'], resolve),
          name: 'greenReport',
        },
        {
          path: '/techReportList',
          component: resolve => require(['@/views/techReport/techReportList'], resolve),
          name: 'techReportList',
        },
        {
          path: '/techReport',
          component: resolve => require(['@/views/techReport/techReport'], resolve),
          name: 'techReport',
        },
        {
          path: '/enterpriseBasicCreditReport',
          component: resolve => require(['@/views/priseBasic/enterpriseBasicCreditReport'], resolve),
          name: 'enterpriseBasicCreditReport',
        },
        {
          path: '/basiContent',
          component: resolve => require(['@/views/priseBasic/basiContent'], resolve),
          name: 'basiContent',
        },
        //电子保函信用风险报告
        {
          path: '/electronicGuaranteeCreditRiskReport',
          component: resolve => require(['@/views/tronicGuar/electronicGuaranteeCreditRiskReport'], resolve),
          name: 'electronicGuaranteeCreditRiskReport',
        },
        //企业经营风险筛查报告
        {
          path: '/businessRiskScreeningReport',
          component: resolve => require(['@/views/business/businessRiskScreeningReport'], resolve),
          name: 'businessRiskScreeningReport',
        },
        {
          path: '/reportIframe',
          component: resolve => require(['@/views/Iframe/iframe'], resolve),
          name: 'reportIframe',
        },
        // 填写页面
        {
          path: '/makeout',
          component: resolve => require(['@/views/business/makeout'], resolve),
          name: 'makeout',
        },
        {
          path: '/Enteriskcont',
          component: resolve => require(['@/views/business/Enteriskcont'], resolve),
          name: 'Enteriskcont',
        },
        //中小企业助贷分析报告
        {
          path: '/smeAssistanceLoanAnalysisReport',
          component: resolve => require(['@/views/smeAssis/smeAssistanceLoanAnalysisReport'], resolve),
          name: 'smeAssistanceLoanAnalysisReport',
        },
        // 中小企业助贷分析报告---填报
        {
          path: '/zdtbform',
          component: resolve => require(['@/views/smeAssis/zdtbform'], resolve),
          name: 'zdtbform',
        },
        // {
        //   path: '/LoanAssistance',
        //   component: resolve => require(['@/views/smeAssis/LoanAssistance'], resolve),
        //   name: 'LoanAssistance',
        // },

        //金融产品
        {
          path: '/financialProducts',
          component: resolve => require(['@/views/marketing/financialProducts'], resolve),
          name: 'financialProducts',
        },
        {
          path: '/Cbapproval',
          component: resolve => require(['@/views/marketing/Cbapproval'], resolve),
          name: 'Cbapproval',
        },
        {
          path: '/Cbapprovals',
          component: resolve => require(['@/views/marketing/Cbapprovals'], resolve),
          name: 'Cbapprovals',
        },
        {
          path: '/jrtblist',
          component: resolve => require(['@/views/marketing/jrtblist'], resolve),
          name: 'jrtblist',
        },
        //申请记录
        {
          path: '/applicationRecord',
          component: resolve => require(['@/views/marketing/applicationRecord'], resolve),
          name: 'applicationRecord',
        },
        // 金融产品-金蝶
        {
          path: '/applkingdeeRecord',
          component: resolve => require(['@/views/marketing/applkingdeeRecord'], resolve),
          name: 'applkingdeeRecord',
        },
        //融资需求
        {
          path: '/financingDemand',
          component: resolve => require(['@/views/financing/financingDemand'], resolve),
          name: 'financingDemand',
        },
        //电子保函
        {
          path: '/electronicGuarantee',
          component: resolve => require(['@/views/finance/electronicGuarantee'], resolve),
          name: 'electronicGuarantee',
        },
        {
          path: '/guaranteeProduct',
          name: 'guaranteeProduct',
          component: resolve => require(['@/views/finance/guaranteeProduct'], resolve),
        },
        {
          path: '/GuaranteeXmIndex',
          name: 'GuaranteeXmIndex',
          component: resolve => require(['@/views/finance/GuaranteeXmIndex'], resolve),
        },
        {
          path: '/GuaranteeFind',
          name: 'GuaranteeFind',
          component: resolve => require(['@/views/finance/GuaranteeFind'], resolve),
        },

        //电子保函-申请记录
        {
          path: '/electronicGuaranRecord',
          component: resolve => require(['@/views/finance/electronicGuaranRecord'], resolve),
          name: 'electronicGuaranRecord',
        },
        {
          path: '/tianan',
          component: resolve => require(['@/views/finance/tianan'], resolve),
          name: 'tianan',
        },
        //履约保函
        {
          path: '/performanceBond',
          component: resolve => require(['@/views/lybh/performanceBond'], resolve),
          name: 'performanceBond',
        },
        {
          path: '/projectInformation',
          component: resolve => require(['@/views/lybh/projectInformation'], resolve),
          name: 'projectInformation',
        },
        {
          path: '/BondfillIn',
          component: resolve => require(['@/views/lybh/BondfillIn'], resolve),
          name: 'BondfillIn',
        },
        {
          path: '/Bondfile',
          component: resolve => require(['@/views/lybh/Bondfile'], resolve),
          name: 'Bondfile',
        },
        {
          path: '/performanceBondRecord',
          component: resolve => require(['@/views/lybh/performanceBondRecord'], resolve),
          name: 'performanceBondRecord',
        },
        // 金蝶效贷
        {
          path: '/ProductCenters',
          component: resolve => require(['@/views/JDXD/ProductCenters'], resolve),
          name: 'ProductCenters',
        },
        {
          path: '/Productcontent',
          component: resolve => require(['@/views/JDXD/Productcontent'], resolve),
          name: 'Productcontent',
        },






      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js